import { marshall, unmarshall } from "@aws-sdk/util-dynamodb";
class FuseUtilBase {
    fuse_marshallFromJson(jsonData) {
        const marshalled = marshall(jsonData, {
            convertClassInstanceToMap: true,
            convertEmptyValues: true,
            removeUndefinedValues: true,
        });
        return marshalled;
    }
    fuse_unmarshallToJson(dynamoData) {
        return unmarshall(dynamoData);
    }
}
export const FuseUtil = new FuseUtilBase();
